import { loadView } from '@/router'

export default [
  {
    path: 'fuellevies',
    name: 'manage-fuellevies',
    component: loadView('Application/Manage/FuelLevies'),
    showInAlfred: true,
    alfredTitle: 'Manage - Fuel Levies'
  }
]
